import React from "react";
import { FiSearch } from "react-icons/fi";

const TravelExpenseApprovalFilters = ({
  search,
  status,
  onSearchChange,
  onStatusChange,
  onSearch,
}) => {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center gap-3 mb-5">
      <div className="relative w-full sm:w-[420px]">
        <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
        <input
          type="text"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="ค้นหาผู้ขอ / ต้นทาง / ปลายทาง..."
          className="w-full rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-900 pl-10 pr-3 py-2.5 text-sm text-gray-700 dark:text-gray-200 focus:ring-2 focus:ring-blue-400 focus:border-blue-400 transition-all"
        />
      </div>

      <select
        value={status}
        onChange={(e) => onStatusChange(e.target.value)}
        className="border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-900 rounded-lg px-3 py-2.5 text-sm text-gray-700 dark:text-gray-200 focus:ring-2 focus:ring-blue-400 focus:border-blue-400 transition-all w-full sm:w-[180px]"
      >
        <option value="Pending">Pending</option>
        <option value="Approved">Approved</option>
        <option value="Rejected">Rejected</option>
        <option value="All">All</option>
      </select>

      <button
        type="button"
        onClick={onSearch}
        className="px-4 py-2.5 rounded-lg bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium transition-all w-full sm:w-auto"
      >
        Search
      </button>
    </div>
  );
};

export default TravelExpenseApprovalFilters;